import React from 'react'
import Sidebar from './components/sidebar/sidebar'
import Main from './components/main/Main'
const App = () => {
  return (
    <>
    <Sidebar/>
    <Main/>
    </>
  )
}

export default App